import React from "react";

/**
 * WhatsApp click-to-chat link.
 * - Strips non-digits from the phone
 * - Opens https://wa.me/<phone>?text=<msg> in a new tab
 * - Gracefully renders "—" when phone is missing
 */
export default function WhatsAppLink({ phone, message = "", label = "WhatsApp", testid, className = "" }) {
  if (!phone) return <span className="text-navy/30 text-xs">—</span>;
  const digits = String(phone).replace(/[^\d]/g, "");
  const url = `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center gap-1.5 text-emerald-700 hover:text-emerald-900 transition-colors ${className}`}
      data-testid={testid}
      aria-label={`Send WhatsApp message to ${phone}`}
      title={`WhatsApp ${phone}`}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.87 11.87 0 0012.03 0C5.53 0 .25 5.28.25 11.78c0 2.08.55 4.11 1.6 5.9L0 24l6.5-1.71a11.75 11.75 0 005.52 1.4h.01c6.5 0 11.78-5.28 11.78-11.78 0-3.15-1.23-6.11-3.29-8.43zM12.03 21.5h-.01a9.75 9.75 0 01-4.97-1.36l-.36-.21-3.86 1.01 1.03-3.76-.23-.39a9.7 9.7 0 01-1.49-5.02c0-5.39 4.39-9.78 9.79-9.78a9.76 9.76 0 019.78 9.78c0 5.4-4.39 9.73-9.68 9.73zm5.6-7.28c-.31-.15-1.82-.9-2.11-1s-.5-.15-.71.15c-.21.31-.81 1-.99 1.21-.18.21-.36.23-.67.08-.31-.15-1.3-.48-2.47-1.52-.91-.81-1.53-1.81-1.71-2.12-.18-.31-.02-.48.14-.63.14-.14.31-.36.47-.54.16-.18.21-.31.31-.52.1-.21.05-.39-.03-.54-.08-.15-.71-1.71-.97-2.34-.25-.61-.51-.52-.71-.53-.18-.01-.39-.01-.6-.01s-.54.08-.83.39c-.28.31-1.09 1.06-1.09 2.58s1.12 3 1.28 3.21c.15.21 2.2 3.36 5.34 4.71.75.32 1.33.51 1.78.65.75.24 1.43.21 1.97.13.6-.09 1.82-.74 2.08-1.46.26-.72.26-1.34.18-1.46-.07-.13-.28-.21-.59-.36z"/>
      </svg>
      <span className="text-[11px] font-medium uppercase tracking-wider">{label}</span>
    </a>
  );
}
